module.exports = __webpack_public_path__ + "static/media/homebody3.534e84c8.png";